/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { CarrierDeliveryInfoFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { CarrierDeliveryInfoFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const carrierDeliveryInfoDataMock: CarrierDeliveryInfoFragmentFragment = {
  deliverySize: 'S',
};

export function getCarrierDeliveryInfoFragmentedData(data?: CarrierDeliveryInfoFragmentFragment) {
  return makeFragmentData(
    data || carrierDeliveryInfoDataMock,
    CarrierDeliveryInfoFragmentFragmentDoc,
  );
}
